/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * GSS slot occasion metadata.
 */
export interface GssSlotOccasion {
  type?: 'gss_slot';
  /** @minLength 1 */
  slotId: string;
}
